import { accordionClickTracking } from '../../components/GTMEvents';

const description = () => {
  // Query each detail element
  const informationItems = document.querySelectorAll('.pdp-c-description__fact-item');

  informationItems.forEach((infoItem) => {
    // Get its content element
    const infoItemContent = infoItem.querySelector('.pdp-c-description__fact-content');

    // Initialize any infoItem with open attribute just once
    if (infoItem.hasAttribute('open')) {
      infoItemContent.style.height = infoItemContent.scrollHeight + 'px';
    }

    infoItem.addEventListener('click', function () {
      informationItems.forEach((i) => {
        const informationContent = i.querySelector('.pdp-c-description__fact-content');
        // Closing any other tabs
        if (i.hasAttribute('open') && i.dataset.factName !== this.dataset.factName) {
          informationContent.style.height = 0;
          i.removeAttribute('open');
          i.setAttribute('aria-expanded', 'false');
        }
      });

      // Opening tab
      infoItemContent.style.height = infoItemContent.scrollHeight + 'px';
      infoItem.setAttribute('open', '');
      infoItem.setAttribute('aria-expanded', 'true');

      // Defer this block because they are not user-visible tasks
      setTimeout(() => {
        accordionClickTracking(infoItem.dataset.factName, {
          productId: infoItem.dataset.productId,
          productTitle: infoItem.dataset.productTitle,
        });
      }, 0);
    });
  });
};

export default description;
